<template>
  <div class="pro">
    <div
      class="pro-head pointer flex flex-middle"
      @click="checkDetail"
      :style="{
        background: `url(${$oss('trends/ability-bg.png')}) no-repeat`,
        backgroundSize: '100% 100%',
      }"
    >
      <div class="flex-1">
        <div>{{ info.laboratoryAbilityTypeName || "" }}</div>
      </div>
      <div class="pro-tag">
        <div
          v-for="(item, index) in info.laboratoryAbilityQualifications"
          :key="index"
          class="pro-itemtag"
        >
          <el-tag hit>
            {{ item.qualificationName }}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="pro-con">
      <div class="pro-descWrap flex flex-middle">
        <div class="flex-1">
          <div v-if="info.abilityName">
            <div class="pro-desc ellipsis">
              <label>检测名称：</label><span>{{ info.abilityName }}</span>
            </div>
          </div>
          <div v-if="info.checkAccord">
            <div class="pro-desc ellipsis">
              <label>检测依据：</label
              ><span class="ellipsis"> {{ info.checkAccord }}</span>
            </div>
          </div>
          <!-- <div v-if="info.checkMethod">
            <div class="pro-desc">
              <label>检测方法：</label>
              <span>{{ info.checkMethod }}</span>
            </div>
          </div> -->
        </div>
        <div class="pro-btn">
          <el-button type="text" @click="checkDetail">查看详情</el-button>
          <el-button type="text" @click="publishDemand">发布需求</el-button>
        </div>
      </div>
      <div class="lab flex flex-bottom">
        <div class="flex-1">
          <div class="flex flex-middle lab-itemline">
            <div class="pointer" @click="toLab" v-if="info.laboratoryLogo">
              <img :src="info.laboratoryLogo" class="lab-img" />
            </div>
            <div class="lab-name pointer" @click="toLab">
              {{ info.laborarotyName }}
            </div>
          </div>
          <div class="lab-address">
            <label class="lab-label">地址信息：</label>
            <span>{{ info.laboratoryLocationProvince }}</span>
            <span>{{ info.laboratoryLocationCity }}</span>
            <span>{{ info.laboratoryLocationCounty }}</span>
            <span>{{ info.laboratoryAddress }}</span>
          </div>
        </div>
        <div class="lab-tel">
          <img
            class="lab-telicon"
            src="@/assets/icon-bg/tel-icon.png"
            alt="tel"
          />
          <label class="lab-label">服务热线：</label>
          <span>{{ info.laboratoryContactsPhone }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import themeColor from "@/style/variable.scss";
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // themeColor: themeColor,
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  methods: {
    checkDetail() {
      const { laboratoryAbilityId } = this.info;
      this.$jump.push({
        name: "checkProjectDetail",
        query: { id: laboratoryAbilityId },
      });
    },
    toLab() {
      const { laborarotyId } = this.info;
      if (laborarotyId) {
        this.$jump.push({
          name: "labDetail",
          query: { id: laborarotyId },
        });
      }
    },

    publishDemand() {
      if (this.token) {
        this.$jump.push({ name: "releaseReq" });
      } else {
        this.$store.dispatch("login");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.lab {
  border-top: 1px solid #f3f3f3;
  padding: 10px 0;
  &-img {
    width: 100px;
    // height: 72px;
    object-fit: contain;
    margin-right: 12px;
  }
  &-name {
    font-weight: bold;
    // margin-bottom: 8px;
  }
  &-address {
    // margin-bottom: 5px;
    label {
      color: #999999;
      width: 100px;
      margin-right: 12px;
      display: inline-block;
    }
  }
  &-tel {
    color: #0276f8;
  }
  &-telicon {
    width: 30px;
  }
  &-itemline {
    margin: 10px 0;
  }
}
.pro {
  background: white;
  margin: 16px 0;
  &-head {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f3f3f3;
    padding: 0 15px;
    font-size: 15px;
    font-weight: bold;
    color: white;
    // background-size: contain;
  }
  &-con {
    padding: 0 15px;
  }
  &-descWrap {
    padding: 8px 0;
  }
  &-desc {
    // margin-bottom: 5px;
    line-height: 24px;
    display: flex;
    label {
      color: #999999;
      width: 80px;
      margin-right: 12px;
      display: inline-block;
    }
    span {
      width: 660px;
      flex: 1;
    }
  }
  &-tag {
    display: flex;
  }
  &-btn {
    margin-left: 10px;
    ::v-deep .el-button {
      padding: 0;
    }
  }
  &-itemtag {
    margin-left: 12px;
  }
}
</style>
